import React from "react";
import { CardContent, Typography, Stack, Box } from "@mui/material";
import SearchResultLink from "../Search/components/SearchResultCard/SearchResultLink";
import ReceiveFailureAlert from "../ReceiveFailureAlert/ReceiveFailureAlert";
import Card from "@mui/material/Card";
import { useStyles } from "./Receive.styles";
import { ReceiveCardProps } from "./types";

const ReceiveCard: React.FC<ReceiveCardProps> = ({
	receiveType,
	invoiceNumber,
	purchaseOrderNumber,
	store,
	supplier,
	invoiceType,
	totalCostInc,
	totalQty,
	receiveStatus,
	failureReason,
	latestStatusHistory,
	hours,
	dateCreated,
	createdBy,
	id,
	onView,
}) => {
	const classes = useStyles();

	return (
		<Card className={classes.receiveCard}>
			<CardContent sx={{ py: 1, px: 2 }}>
				<Stack spacing={0.5}>
					<Box>
						<Typography display="inline" variant="caption" color="textSecondary" component="div">
							PO Number
						</Typography>
						<Typography display="inline" variant="body2" component="div" className={classes.purchaseOrderNumber}>
							{purchaseOrderNumber}
						</Typography>
					</Box>
					<Box display="flex" gap={1}>
						<Box flex="0 0 58%">
							<Typography variant="caption" color="textSecondary" component="div">
								Date Created
							</Typography>
							<Typography variant="body2" component="div">
								{dateCreated}
							</Typography>
						</Box>
						<Box flexGrow={1}>
							<Typography variant="caption" color="textSecondary" component="div">
								Invoice Type
							</Typography>
							<Typography variant="body2" component="div">
								{invoiceType}
							</Typography>
						</Box>
					</Box>
					<Box display="flex" gap={1}>
						<Box flex="0 0 58%">
							<Typography variant="caption" color="textSecondary" component="div">
								Created By
							</Typography>
							<Typography variant="body2" component="div">
								{createdBy}
							</Typography>
						</Box>
						<Box flexGrow={1}>
							<Typography variant="caption" color="textSecondary" component="div">
								Store
							</Typography>
							<Typography variant="body2" component="div">
								{store}
							</Typography>
						</Box>
					</Box>
					<Box>
						<Typography variant="caption" color="textSecondary" component="div">
							Supplier
						</Typography>
						<Typography variant="body2" component="div">
							{supplier}
						</Typography>
					</Box>
					<Box>
						<SearchResultLink
							key={`${invoiceNumber}`}
							receiveId={id}
							receiveType={receiveType}
							invoiceNumber={invoiceNumber}
							totalQuantity={totalQty}
							totalCostInc={totalCostInc}
							status={receiveStatus}
							onSelect={() => onView(id)}
							highlight={false}
						/>
					</Box>
					<Box>
						<ReceiveFailureAlert status={receiveStatus} latestStatusHistory={latestStatusHistory} failureReason={failureReason} hours={hours} />
					</Box>
				</Stack>
			</CardContent>
		</Card>
	);
};

export default ReceiveCard;
